var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ResearcherSidebar.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-33b6e2c1\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ResearcherSidebar.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/template/ResearcherSidebar.vue
// module id = 614
// module chunks = 1